package com.taager.checkout.payment

sealed interface PaymentFormVisibility {
    object Hidden : PaymentFormVisibility
    data class Visible(val form: PaymentForm) : PaymentFormVisibility
}
